// ABOUTME: Names shared across the interviews module: the pro-core paths, the query key, and the client-side error codes
// ABOUTME: a failure without a usable body is mapped to.
export const GUEST_INTERVIEWS_API_URL = 'guest/interviews';
export const TALENT_INTERVIEWS_API_URL = 'talent/interviews';

export const INTERVIEW_CARD_QUERY_KEY = 'interviewCard';

/** pro-core's own code for an unknown or expired link, another session's interview, or not this talent's. */
export const INTERVIEW_NOT_FOUND_ERROR_CODE = 'error.interview.not-found';

/** A 404 with any other body: PRO_INTERVIEWS is off (pro-core answers error.not-found), or the route is not deployed. */
export const INTERVIEWS_UNAVAILABLE_ERROR_CODE = 'error.interview.unavailable';

/** 401/403: the guest session lapsed, was replaced by a newer redeem, or the token is not a talent's. */
export const INTERVIEW_SESSION_EXPIRED_ERROR_CODE =
  'error.interview.session-expired';

/** A failure pro-core did not name: a dropped connection, a proxy page. */
export const INTERVIEW_UNKNOWN_ERROR_CODE = 'error.interview.unknown';

/** The `answer` values the "Still on?" email adds to its link (interview.talent.still-on templates). */
export const STILL_ON_ANSWERS = ['confirm', 'rebook', 'cancel'] as const;
export type StillOnAnswer = (typeof STILL_ON_ANSWERS)[number];

/** How often the card re-reads the clock, so the join button appears when the room opens without a reload. */
export const CLOCK_TICK_MS = 30_000;

/** The note limit of the Interview Timeline (MoveInterviewHttp, CancelInterviewHttp). */
export const NOTE_MAX_LENGTH = 1000;

/** Rows of the propose form. The policy's maxProposals is not on the card, so pro-core has the final word. */
export const MAX_PROPOSAL_ROWS = 3;
